export function toInt(value: string|number) : number {
    if(typeof value === 'number'){
        return value
    }

    return parseInt(value)
}

export function toFloat(value: string|number) : number {
    if(typeof value === 'number'){
        return value
    }

    return parseFloat(value)
}